import type { ReactNode } from "react";

import { AccountAccessProvider } from "./AccountAccessProvider";
import AccountProvider from "./AccountProvider";

export const AccountProviders = ({ children }: { children: ReactNode }) => (
  <AccountProvider>
    <AccountAccessProvider>{children}</AccountAccessProvider>
  </AccountProvider>
);
